import React from 'react';
import {isFormValid, validated} from 'react-custom-validation';
import PropTypes from 'prop-types';
import update from "immutability-helper";

import { isEqual, isRequired } from '../../util/validations';
import { handleTextChange } from '../../util/handle-changes';

import Button from '../../_components/FormComponents/Button';
import Form from '../../_components/FormComponents/Form';
import FormValidationMessage from '../../_components/FormComponents/FormValidationMessage';
import FormRow from '../../_components/FormComponents/FormRow';
import Textbox from '../../_components/FormComponents/Textbox';
import {Link} from "react-router-dom";

class ResetPasswordForm extends React.Component {
    static propTypes = {
        credentials: PropTypes.object.isRequired,
        error: PropTypes.object,
        isResettingPassword: PropTypes.bool.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        setCredentials: PropTypes.func.isRequired,
    };

    handleChange = (name, value) => {
        let newCredentialsObj = update(this.props.credentials, {});
        newCredentialsObj[name] = value;
        this.props.setCredentials(newCredentialsObj);
    };

    render() {
        let { credentials, error, isResettingPassword, handleSubmit, $field, $validation } = this.props;

        return (
            <Form className="auth-page__form">
                <FormRow>
                    <Textbox
                        id="txtPassword"
                        label="New Password"
                        labelHidden
                        name="password"
                        placeholder='New Password'
                        required
                        type="password"
                        validation={$validation.password}
                        value={credentials.password || ''}
                        {...$field('password', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                <FormRow>
                    <Textbox
                        id="txtPassword2"
                        label="Confirm New Password"
                        labelHidden
                        name="password2"
                        placeholder='Confirm New Password'
                        required
                        type="password"
                        validation={$validation.password2}
                        value={credentials.password2 || ''}
                        {...$field('password2', (event) => handleTextChange(this.handleChange, event))}
                    />
                </FormRow>

                {error && Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                <div className="auth-page__form__footer">
                    <p className="auth-page__help-text">
                        <Link to="/login">Login</Link>
                    </p>
                    <FormRow className="c-form__button-wrapper">
                        <Button disabled={isFormValid($validation) !== true || isResettingPassword === true}
                                className='c-button--block'
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.props.$submit(() => handleSubmit(true), () => handleSubmit(false));
                                }}
                                showActivityIndicator={isResettingPassword}
                                type="submit">
                            Reset Password
                        </Button>
                    </FormRow>
                </div>

            </Form>
        )
    }
}

function resetPasswordFormValidationConfig(props) {
    const { password, password2 } = props.credentials;

    return {
        fields: ['password', 'password2'],
        validations: {
            password: [
                [isRequired, password]
            ],
            password2: [
                [isRequired, password2],
                [isEqual, password, password2, 'Passwords must match']
            ]
        }
    }
}

export default ResetPasswordForm = validated(resetPasswordFormValidationConfig)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/PasswordResetForm.js